export default __webpack_public_path__ + "img/react.0e8c9066.jpg";